import { GetterTree } from "vuex";

import { IFlightBooking } from "@/core/interfaces/IFlightBooking.interface";
import { Traveler } from "@/core/types/flight/FlightBookingForm";
import { StoreState } from "@/store/type";
import { AdditionalPassengerField, MANDATORY_STAGE } from "@/core/types/flight";
import { BOOKING_STATUS } from "@/core/enums/BOOKING_STATUS";
import { normalizeFlightDetailsPassengers } from "../utils/addonsFlightDetails";

const getters: GetterTree<IFlightBooking, StoreState> = {
  bookingId: (state): string | null => state.bookingId,
  isFlightBookingLoading: (state): boolean => state.isLoading,
  isFlightConfirmBookingLoading: (state): boolean =>
    state.confirmBookingLoading,
  flightTravelers: (state): Array<Traveler> => state.travelers,
  flightBookingStatus: (state): string => state.bookingStatus,
  isAddonsEnabled: (state): boolean => state.isAddonsEnabled,
  addonsStatus: (state): string => state.addonsStatus,
  isAddonsPending: (state): boolean =>
    state.isAddonsEnabled &&
    state.addonsStatus.toUpperCase() === BOOKING_STATUS.ADDONS_PENDING,
  flightDetails: (state) =>
    normalizeFlightDetailsPassengers(state.flightDetails),
  mobileNumber: (state) => state.mobileNumber,
  isFlightCancelBookingLoading: (state) => state.cancelBookingLoading,
  isDownloadTicketLoading: (state) => state.downloadTicketLoading,
  isVoidFlightTicketLoading: (state) => state.voidTicketLoading,
  passengers: (state) => state.passengers,
  editPassengerApiErrors: (state) => state.editPassengerApiErrors,
  areMissingRequiredIssuanceFields(state) {
    const flightDetails = normalizeFlightDetailsPassengers(state.flightDetails);
    const passengers = flightDetails?.passengers;
    if (!passengers || passengers.length === 0) {
      return false;
    }

    return passengers.some((passenger) => {
      if (!passenger.additional_data) {
        return false;
      }
      return passenger.additional_data.some(
        (field: AdditionalPassengerField) =>
          field.is_mandatory &&
          field.mandatory_stage === MANDATORY_STAGE.ISSUANCE &&
          (field.value === null ||
            field.value === "" ||
            typeof field.value === "undefined"),
      );
    });
  },
  isPassengerFetching: (state) => state.isPassengerLoading,
  errors: (state) => state.errors,
  bookingActions: (state) => state.bookingActions,
  pnrExpiryDate: (state) => state.pnrExpiryDate,
  supplierPnr: (state) => state.flightDetails?.supplier_pnr,
  bookingPromoDealDetails: (state) => state.bookingPromoDealDetails,
  availableAddOns: (state) => state.availableAddOns,
  organizationUser: (state) => state.organizationUser,
  createdBy: (state) => state.createdBy,
  additionalPassengerFields: (state) => state.additionalPassengerFields,
  isFlightAddOnsLoading: (state) => state.isAddOnsLoading,
  isFlightSkipAddOnsLoading: (state) => state.isSkipAddOnsLoading,
  extraMeals: (state) => state.extraMeals,
  extraBaggages: (state) => state.extraBaggages,
  extraSeats: (state) => state.extraSeats,
  contactPhone: (state) => state.contact_phone,
  AdditionalSurcharges: (state) => state.AdditionalSurcharges,
  bookingAlerts: (state) => state.bookingAlerts,
  approvalRequest: (state) => state.approvalRequest,
  frequentFlyersAllowed: (state) => state.frequentFlyersAllowed,
  organizationName: (state) => state.organizationName,
  platformId: (state) => state.platformId,
  getMarketingAirlineCodes: (state: IFlightBooking) =>
    state.marketingAirlineCodes,
  bookingOrganizationId: (state) => state.organizationId,
};

export default getters;
